// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mNy6COab4Fzvn7RakLsA {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mNy6COab4Fzvn7RakLsA img {
  width: 300px;
}
@media (max-width: 1025px) {
  .mNy6COab4Fzvn7RakLsA img {
    width: 210px;
  }
}
@media (orientation: portrait) {
  .mNy6COab4Fzvn7RakLsA {
    margin-bottom: 9px;
  }
}
.TnOQM_JVE4t48eVoF6Ol img {
  width: 171px;
}
@media (max-width: 1025px) {
  .TnOQM_JVE4t48eVoF6Ol img {
    width: 130px;
  }
}
@media (max-width: 376px) {
  .TnOQM_JVE4t48eVoF6Ol img {
    width: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/Static/Static.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".staticTheme {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.staticTheme img {\n  width: 300px;\n}\n@media (max-width: 1025px) {\n  .staticTheme img {\n    width: 210px;\n  }\n}\n@media (orientation: portrait) {\n  .staticTheme {\n    margin-bottom: 9px;\n  }\n}\n.highRtpStaticTheme img {\n  width: 171px;\n}\n@media (max-width: 1025px) {\n  .highRtpStaticTheme img {\n    width: 130px;\n  }\n}\n@media (max-width: 376px) {\n  .highRtpStaticTheme img {\n    width: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staticTheme": `mNy6COab4Fzvn7RakLsA`,
	"highRtpStaticTheme": `TnOQM_JVE4t48eVoF6Ol`
};
export default ___CSS_LOADER_EXPORT___;
